import { WrapText } from '@material-ui/icons';
import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import MouseActionNode from './MouseActionNode';
export default memo(({ data }) => {

    
    var style = {
        backgroundImage:'linear-gradient( to right, lightgrey, white)',
        textAlign:'center',
        // width:650,
        // height:400
    
    } 


    const renderNode = () =>{
      // data: { label: name, attributes:item, type:type, entity:entityName, screenImage:screenImage }
      return (
        <div>
            <MouseActionNode data={data}/>
        </div>
      )
    }
    

    const renderImage = () =>{
      return (
        <img draggable={false} src={data.screenImageData} width='650' height='400'></img>
      );

      
    } 

    return (
    <div style={style}>
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {renderImage()}
      <p style={ {textAlign: 'center', width:600, overflow: "hidden", textOverflow: "ellipsis"}}>
        <h4>{data.screenAttributes["description"]}  </h4>
        <h4>{data.screenAttributes["notes"]}  </h4>
        
        </p> 
      {renderNode()}
      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});